'use client';

import { c as _c } from "react/compiler-runtime";
import { getDataWrapperSchema } from '@repo/schema/data-wrapper';
import { GetLoadTypeSchema } from '@repo/schema/load';
import { useDbSessionQueryCollection } from '@repo/tanstack/db';
import { useBaseUpFetch } from '@repo/upfetch';
import { groupLoadTypes } from './group-load-types.ts';
const LOAD_TYPES_QUERY_KEY = ['/public/load-types'] as const;
const LoadTypesSchema = getDataWrapperSchema(GetLoadTypeSchema.array());
export const useFetchLoadTypes = () => {
  const $ = _c(10);
  const upfetch = useBaseUpFetch();
  let t0;
  if ($[0] !== upfetch) {
    t0 = {
      getKey: _temp,
      id: "load-types",
      queryFn: () => upfetch("/public/load-types", {
        schema: LoadTypesSchema
      }),
      queryKey: LOAD_TYPES_QUERY_KEY,
      schemaVersion: 1,
      staleTime: 300000
    };
    $[0] = upfetch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = useDbSessionQueryCollection(t0);
  let data;
  let state;
  if ($[2] !== t1) {
    ({
      data,
      ...state
    } = t1);
    $[2] = t1;
    $[3] = data;
    $[4] = state;
  } else {
    data = $[3];
    state = $[4];
  }
  let t2;
  if ($[5] !== data) {
    t2 = data === undefined ? undefined : groupLoadTypes(data);
    $[5] = data;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== state || $[8] !== t2) {
    t3 = {
      ...state,
      data: t2
    };
    $[7] = state;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export const useAllLoadTypes = () => {
  const $ = _c(8);
  const t0 = useFetchLoadTypes();
  let data;
  let rest;
  if ($[0] !== t0) {
    ({
      data,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== data?.grouped) {
    t1 = data?.grouped ?? [];
    $[3] = data?.grouped;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== rest || $[6] !== t1) {
    t2 = {
      data: t1,
      ...rest
    };
    $[5] = rest;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(row) {
  return row.id;
}